/**
 * Price rendering: product cards & non-PDP surfaces.
 * Uses variant metafields from snippets/price.liquid (data-price-*).
 */
if (!window.Maximize?.loadedScript?.includes("price-rendering-cards.js")) {
  if (window.Maximize?.loadedScript) {
    window.Maximize.loadedScript.push("price-rendering-cards.js");
  }

  (function () {
    const LOCATION_READY = "maximize:catalog:ready";
    const VARIANT_UPDATED_PREFIX =
      (typeof PRODUCT_EVENT !== "undefined" && PRODUCT_EVENT.updatedVariant) ||
      "maximize:variant-picker:updated:";
    const PRICE_SELECTOR =
      ".price__container[data-sku], .price__container[data-product-handle]";
    const PDP_MAIN_SCOPE =
      "product-info, .section-main-product, .section-product-details";
    const QUICK_VIEW_SCOPE =
      "#QuickViewContainer, #QuickViewProductContent, .section-quick-view";

    function debounce(fn, wait) {
      let t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    function money(dollarsString) {
      if (dollarsString == null) return null;
      const amount = Number(String(dollarsString).trim());
      if (!Number.isFinite(amount)) return null;
      const cents = Math.round(amount * 100);
      const fmt = window.Maximize.moneyFormat;
      if (typeof formatMoney === "function" && fmt) {
        try {
          return formatMoney(cents, fmt);
        } catch (_) {
          /* fall through */
        }
      }
      return amount.toFixed(2);
    }

    function activeLocationKey() {
      let name = "";
      try {
        if (window.Alpine && Alpine.store("xStoreMap")?.currentStoreSelected) {
          name = Alpine.store("xStoreMap").currentStoreSelected;
        }
      } catch (_) {
        /* ignore */
      }
      if (!name) {
        try {
          const s = JSON.parse(localStorage.getItem("currentStoreSelected") || "null");
          name = (s && s.selectedStore) || "";
        } catch (_) {
          /* ignore */
        }
      }
      const v = String(name).toLowerCase();
      if (v.indexOf("mississauga") >= 0) return "mississauga";
      if (v.indexOf("windsor") >= 0) return "windsor";
      if (v.indexOf("halifax") >= 0) return "halifax";
      return null;
    }

    function priceFromMetafields(container) {
      const loc = activeLocationKey();
      if (!loc) return null;
      const raw = container.getAttribute("data-price-" + loc);
      if (raw == null || raw === "") return null;
      const amount = Number(raw);
      if (!Number.isFinite(amount) || amount <= 0) return null;
      return { price: raw };
    }

    function renderInto(container, priceData) {
      const formattedPrice = money(priceData.price);
      if (formattedPrice == null) return;

      container
        .querySelectorAll(".price:not(.compare-at-price), .main-price")
        .forEach((el) => {
          el.textContent = formattedPrice;
        });
      const compareEl = container.querySelector(".compare-at-price");
      if (compareEl) compareEl.classList.add("hidden");
      container.setAttribute("data-catalog-priced", "true");
    }

    function isMainPdpPrice(container) {
      if (container.closest(QUICK_VIEW_SCOPE)) return false;
      return Boolean(container.closest(PDP_MAIN_SCOPE));
    }

    function priceOne(container) {
      if (isMainPdpPrice(container)) return;
      const priceData = priceFromMetafields(container);
      if (!priceData) return;
      renderInto(container, priceData);
    }

    function priceAll(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(PRICE_SELECTOR).forEach(priceOne);
    }

    function wireQuickViewVariantEvents(root) {
      const scope = root?.querySelectorAll ? root : document.getElementById("QuickViewProductContent");
      if (!scope?.querySelectorAll) return;
      const els = [
        ...(scope.matches?.("[data-section-id]") ? [scope] : []),
        ...scope.querySelectorAll("[data-section-id]"),
      ];
      els.forEach((el) => {
        const sid = el.dataset.sectionId;
        if (!sid) return;
        const evt = VARIANT_UPDATED_PREFIX + sid;
        if (el.__qvPriceWired === evt) return;
        el.__qvPriceWired = evt;
        document.addEventListener(evt, () => priceAll(scope));
      });
    }

    document.addEventListener(LOCATION_READY, () => priceAll());
    document.addEventListener("maximize:store-changed", () => priceAll());
    document.addEventListener("maximize:quickview:loaded", (e) => {
      const root = e?.detail?.root || document.getElementById("QuickViewProductContent");
      priceAll(root);
      wireQuickViewVariantEvents(root);
    });

    const repriceSoon = debounce(() => priceAll(), 100);
    function startObserver() {
      const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (
              node.matches?.(".price__container") ||
              node.querySelector?.(".price__container")
            ) {
              repriceSoon();
              return;
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    function init() {
      priceAll();
      startObserver();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
}
